import React from "react";
import ReactApexChart from "react-apexcharts";

const SurveyDetails = ({ title, data }) => {

  return (
    <div className="shadow-pie-shadow rounded-[10px] bg-white w-full h-auto sm:h-[165px] mt-[14px] py-[14px] pl-[24px] pr-[10px]">
      <h1 className="text-[#06152B] font-medium text-lg mb-[16px]">{title}</h1>

      {/* <Doughnut data={finalData} options={options} />; */}
      <ReactApexChart
        options={data.options}
        series={data.series}
        type="donut"
      />
    </div>
  );
};

export default SurveyDetails;
